export const SMART_COMPONENT_LIST = ["DEVICE_COMPATIBILITY_CHECKER"];

const SmartComponents = {};

SMART_COMPONENT_LIST.forEach(name => {
  SmartComponents[name] = require(`./${name}`)?.default;
});

export default SmartComponents;
